import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const audiences = [
  {
    icon: 'ri-advertisement-line',
    title: 'Маркетологи',
    desc: 'У вас клиенты на рекламе, которым нужны результаты. Добавьте AIGAM в свой арсенал — получите предсказуемый поток заявок без настройки таргета.',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Агентства',
    desc: 'Масштабируйте услуги без роста команды. Берите клиентов на лидогенерацию — мы делаем всё под капотом, вы получаете маржу.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Фрилансеры',
    desc: 'Работаете с бизнесом напрямую? Предлагайте поставку заявок как дополнительную услугу. Работает как пассивный доход при тех же усилиях.',
  },
  {
    icon: 'ri-presentation-line',
    title: 'Бизнес-консультанты',
    desc: 'Помогаете клиентам расти? Закройте их потребность в лидах — мы обеспечим результат, вы сохраните экспертный статус.',
  },
  {
    icon: 'ri-group-line',
    title: 'Посредники и байеры',
    desc: 'Сводите бизнес с подрядчиками? Добавьте лидогенерацию AIGAM в портфель — это услуга, которая нужна каждому вашему контакту.',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'Владельцы продуктов',
    desc: 'У вас есть SaaS или сервис, и вы хотите привлекать больше клиентов? Рекомендуйте AIGAM своим партнёрам и клиентам — получайте комиссию.',
  },
];

export default function PartnerWhoFor() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 200 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(6);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Для кого
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Кому подходит партнёрская программа AIGAM
          </h2>
          <p ref={descRef} className={`mt-4 text-[15px] md:text-[16px] text-foreground-500 max-w-2xl mx-auto leading-relaxed reveal-fade-up ${descRevealed ? 'revealed' : ''}`}>
            Необязательно быть экспертом в лидогенерации. Если у вас есть контакты с бизнесом, который ищет клиентов — вы уже можете зарабатывать.
          </p>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {audiences.map((item, i) => (
            <div
              key={item.title}
              className={`rounded-2xl bg-background-100 border border-background-200/70 p-5 md:p-6 hover:border-primary-500/40 transition-all duration-300 group reveal-fade-up ${i < cardsRevealed ? 'revealed' : ''}`}
              style={i < cardsRevealed ? { transitionDelay: `${i * 80}ms` } : undefined}
            >
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 group-hover:scale-110 transition-all">
                <i className={`${item.icon} text-primary-600 text-lg`}></i>
              </div>
              <h3 className="font-display font-bold text-[16px] md:text-[17px] text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-[13px] md:text-[14px] text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}